import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import React, { useEffect, useState } from "react";

/**
 * TaskCardActions - Actions section of a task card
 *
 * @param {Object} props
 * @param {boolean} props.isEditing - Whether task is in edit mode
 * @param {boolean} props.isDeleting - Whether task is being deleted
 * @param {boolean} props.isUploading - Whether files are being uploaded
 * @param {Function} props.onSave - Save handler
 * @param {Function} props.onCancel - Cancel handler
 * @param {Function} props.onDelete - Delete handler
 */
const TaskCardActions = ({
  isEditing,
  isDeleting,
  isUploading,
  onSave,
  onCancel,
  onDelete,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
          "ontouchstart" in window ||
          navigator.maxTouchPoints > 0
      );
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Icon size based on device
  const iconSize = isMobile ? "1.5rem" : "1.2rem";

  return (
    <div className="flex justify-end space-x-3 mt-3">
      {isEditing ? (
        <>
          <button
            type="button"
            onClick={onCancel}
            className="text-gray-400 hover:text-white p-1"
            title="Cancel"
            disabled={isUploading}
          >
            <sl-icon name="x-circle" style={{ fontSize: iconSize }}></sl-icon>
          </button>
          <button
            type="button"
            onClick={onSave}
            className="text-[#4db1e0] hover:text-white p-1"
            title="Save"
            disabled={isUploading}
          >
            <sl-icon
              name="check-circle"
              style={{ fontSize: iconSize }}
            ></sl-icon>
            {isUploading && <span className="ml-1 text-xs">Uploading...</span>}
          </button>
        </>
      ) : (
        <>
          <button
            type="button"
            onClick={onDelete}
            className="text-gray-400 hover:text-red-400 p-1"
            title="Delete"
            disabled={isDeleting}
          >
            <sl-icon name="trash" style={{ fontSize: iconSize }}></sl-icon>
            {isDeleting && <span className="ml-1 text-xs">Deleting...</span>}
          </button>
        </>
      )}
    </div>
  );
};

export default TaskCardActions;
